import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Field from '../components/Field.jsx'
import FormAlert from '../components/FormAlert.jsx'
import { api, ApiError } from '../lib/api.js'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [alert, setAlert] = useState(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    document.title = 'Reset your password — Sonologue'
  }, [])

  async function onSubmit(event) {
    event.preventDefault()
    setBusy(true)
    setAlert(null)
    try {
      await api.requestPasswordReset({ email })
      setSent(true)
    } catch (error) {
      // Only a rate limit or an outage reaches here. "No such account" does
      // not: the endpoint answers 202 either way.
      setAlert(error instanceof ApiError ? error.message : 'Something went wrong. Try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth-shell">
      <div className="card card-pad auth-card fade-up">
        <h1 className="auth-heading">Reset your password</h1>
        {sent ? (
          <p className="auth-sub">
            If that address has an account, a reset link is on its way. The link is good for one
            use.
          </p>
        ) : (
          <>
            <p className="auth-sub">We’ll send a single-use link to your email address.</p>
            <FormAlert>{alert}</FormAlert>
            <form onSubmit={onSubmit} noValidate>
              <Field
                label="Email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
                required
              />
              <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
                {busy ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
          </>
        )}
        <p className="auth-alt">
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}
